import React, { useState } from "react";
import { CiEdit } from "react-icons/ci";
import { useStores } from "../../../store";

const Badge = ({ title, count, color, width, id, description }) => {
  const [hover, setHover] = useState(false);
  const { PopupStore, LabelStore } = useStores();
  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={`flex items-center justify-between ${
        width ?? width
      }  text-white  rounded-md mt-2 ml-1 `}
    >
      <div
        style={{ backgroundColor: `${color}AA` }}
        className={`flex justify-between h-61px   bg-opacity-80 rounded-lg py-2 px-3 lg:w-full md:w-full w-[300px]`}
      >
        <p className="text-sm  whitespace-nowrap  font-semibold lg:block md:block w-60">
          {title}
        </p>
        <div className="flex justify-center items-center cursor-pointer">
          {hover ? (
            <CiEdit
              onClick={() => {
                LabelStore.setSelctedLabel(id);
                LabelStore.setSelectedLebelValues({
                  name: title,
                  color: color,
                  description: description,
                });
                PopupStore.setLabelEditPopup(true);
              }}
            />
          ) : (
            <CiEdit
              className="invisible"
              onClick={() => PopupStore.setLabelEditPopup(true)}
            />
          )}
          <div
            style={{ backgroundColor: `${color}` }}
            className={`ml-2 bg-[${color}] text-white  rounded-md text-xs font-bold px-3 py-1`}
          >
            {count}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Badge;
